export interface AvailableDates {
  availableDates: string[];
}

export interface AvailableDatesResponse extends AvailableDates {}

export interface AvailableDatesParams {
  language: string;
  month: string;
  stateCode: string;
  timeZone: string;
}
export interface UseQueryAvailableDatesParams extends AvailableDatesParams {}

export interface GeneticCounselorProfile {
  firstName: string;
  id: number;
  lastName: string;
}
export interface TimeRange {
  appointmentTypeID: number;
  duration: number;
  endTime: string;
  geneticCounselorProfile: GeneticCounselorProfile;
  startTime: string;
}

export interface FormattedTimeRange {
  duration: number;
  startTime: string;
  endTime: string;
  formattedTimeRange: string;
}

export interface AvailableTimeRanges {
  availableDatetimes: TimeRange[];
}

export interface AvailableTimeRangesResponse extends AvailableTimeRanges {}

export interface AvailableTimeRangesParams {
  date: string;
  language: string;
  stateCode: string;
  timeZone: string;
}

export interface UseQueryAvailableTimeRangesParams extends AvailableTimeRangesParams {}

export interface BookAppointmentValues {
  notesForAppointment?: string;
  event: EventTypeId;
  eventDateTime: string;
  startTime: string;
  endTime: string;
  acuityAppointmentTypeID: number;
  gcProfileID: number;
  timeZone: string;
  consentToGeneticCounseling?: boolean;
  consentToGeneticCounselingAt?: string;
  consentToShareResults?: boolean;
  consentToShareResultsAt?: string;
}

export interface BookAppointmentProps {
  id: string;
  values: BookAppointmentValues;
}

export interface BookAppointmentParams extends BookAppointmentValues {}

export interface UseMutationBookAppointmentParams extends BookAppointmentValues {}

export interface DeclineReferralValues {
  declinedReasonNotes: string | undefined;
  event: EventTypeId.decline;
  eventDateTime: string;
  reasonCode?: string;
  reasonDescription?: string;
}

export interface RegisterContactAttemptValues {
  declinedReasonNotes: string | undefined;
  event: EventTypeId.attempt;
  eventDateTime: string;
}

export interface DeclineReferralProps {
  id: string;
  values: DeclineReferralValues;
}

export interface RegisterContactAttemptProps {
  id: string;
  values: RegisterContactAttemptValues;
}

export interface DeclineReferralParams extends DeclineReferralValues {}

export interface UseMutationDeclineReferralParams extends DeclineReferralValues {}

export enum EventTypeId {
  attempt = 'Attempt',
  cancel = 'Cancel',
  decline = 'Decline',
  reopen = 'Reopen',
  reschedule = 'Reschedule',
  schedule = 'Schedule',
}
